import { useErrorStore } from '@/stores/errorStore';
import { showDialog, showToast } from '@/utils/swal';

export function handleError(error, toast = false, fallbackMessage = 'Something went wrong.') {
	const errorStore = useErrorStore();
	
	if (!errorStore.isNotFound && !errorStore.isUnauthorized) {
		let title = 'Error';
		let icon = 'error';
		let message = error?.response?.data?.message || error?.message || fallbackMessage;

		if(toast) {
			showToast({
				title,
                text: message,
                icon,
			})
		} else {
			if(message == "The learner's subscription has expired.") {
				message = "The learner's subscription has expired. Please assign a new subscription.";
				icon = 'warning';
				title = 'Warning';
			}

			showDialog({
				title,
				icon,
				html: message
			});
		}
	}
}
